import { API } from "aws-amplify"
import { useQuery } from "@tanstack/react-query"

const fetchProjectSummary = async projectId => {
  const res = await API.get("CORE", `/projects/${projectId}/summary`)
  return res
}

export const useProjectSummary = (projectId, enabled = false) => {
  return useQuery({
    queryKey: ["project-summary", projectId],
    queryFn: () => fetchProjectSummary(projectId),
    enabled,
  })
}
